import React, { useEffect, useRef, useState } from 'react';
import Input from '../../ui/input';
import Label from '../../ui/label';
import { getZones } from '../../../redux/api/zoneAPI';
import { getSites } from '../../../redux/api/siteAPI';
import { validateCamera } from '../../../model/CameraModel';
import { cameraUpdate, getProducts } from '../../../redux/api/cameraAPI';
import Select from '../../ui/select';
import Textarea from '../../ui/textarea';
import FallbackLoading from '../../loader/FallbackLoading';
import Button from '../../ui/button';
import useFeatureFlag from '../../../hooks/useFeatureFlag';
import { useTranslation } from 'react-i18next';
const zones = [
    {
        Zone_ID: 1,
        Zone_name: "zone1"
    },
    {
        Zone_ID: 2,
        Zone_name: "zone2"
    },
    {
        Zone_ID: 3,
        Zone_name: "zone3"
    },
]

const sites = [
    {
        Site_ID: 1,
        Name: "yard 1"
    },
    {
        Site_ID: 2,
        Name: "Room 2"
    },
    {
        Site_ID: 3,
        Name: "Hallway 1"
    },
]

const EditCameraModal = ({ data, isOpen, onClose }) => {
    const {t} = useTranslation('common');
    const { enabled: isRotationFeatureEnabled } = useFeatureFlag('rotation', false);

    const [formData, setFormData] = useState({
        Camera_ID: data.Camera_ID,
        Name: data.Name || "",
        url: data.URL,
        Manufacturer: data.Manufacturer,
        Model: data.Model || "",
        IP_Address: data.IP_address,
        Port_Number: data.Port_number,
        Username: data.Username,
        Password: data.Password,
        Zone: data.Zone_ID,
        ZoneName: data.zone?.Zone_name ? data.zone.Zone_name : "",
        Status: data.Status,
        Site: data.zone?.site?.Site_ID ? data.zone.site.Site_ID : "",
        SiteName: data.zone?.site?.Name ? data.zone.site.Name : "",
        // fps: data.fps
        Rotation: data.Rotation === 1,
        Rotation_degree: data.Rotation_degree ?? 0,
    });
    // console.log("formdata", formData)

    const [formErrors, setFormErrors] = useState({});
    const [error, setError] = useState({});
    const [loading, setLoading] = useState(true);
    const [zonesList, setZonesList] = useState([]);
    const [sitesList, setSitesList] = useState([]);
    const [errorEdit, setErrorEdit] = useState(null);
    const [products, setProducts] = useState([]);
    const debounceTimeoutRef = useRef(null);

    useEffect(() => {
        const fetchInitialData = async () => {
            setLoading(true);
            try {
                const [zonesRes, sitesRes, prodRes] = await Promise.all([
                    getZones(),
                    getSites(),
                    getProducts(),
                ]);
                setZonesList(zonesRes.data.zones);
                setSitesList(sitesRes.data.sites);
                setProducts(prodRes.data)

            } catch (err) {
                setError(err);
                //static
                setZonesList(zones);
                setSitesList(sites);
            } finally {
                setLoading(false);
            }
        };
        fetchInitialData();
    }, [data]);
    useEffect(() => {
        if (products.length > 0 && formData.Model) {
            const cam = products.find(cam => cam.model == formData.Model)
            console.log(cam)
            if (cam)
                setFormData({ ...formData, productID: cam.id });
        }
    }, [products])

    const [site, setSite] = useState(null)
    const [zone, setZone] = useState(null)
    useEffect(() => {
        const fetchData = async () => {
            // setLoading(true);
            try {
                const [sitesRes, zonesRes] = await Promise.all([
                    getSites(),
                    getZones()
                ]);
                setSitesList(sitesRes.data.sites)
                setZonesList(site ? zonesRes.data.zones.filter(zone => zone.Site_ID === site.Site_ID) : zonesRes.data.zones)

            } catch (err) {
                setError(err);
                //static

            } finally {
                // setLoading(false);
            }
        };
        fetchData();
    }, [zone, site]);
    const handleSelectZone = (option) => {
        if (option) {
            const foundZone = zonesList.find(zone => zone.Zone_ID === option.value);
            setZone(foundZone)
            setSite(foundZone?.site || null)
            setFormData(prevState => ({ ...prevState, Zone: option.value, site: foundZone?.site || null }))

        }
        else {
            setFormData(prevState => ({ ...prevState, Site: null, zone: null }))
            setZone(null)
            setSite(null)
        }
    }
    const handleSelectSite = (option) => {
        if (option) {
            setFormData(prevState => ({ ...prevState, Site: option.value }))
            const foundSite = sitesList.find(site => site.Site_ID === option.value);
            setZone(null)
            setSite(foundSite)
        }
        else {
            setFormData(prevState => ({ ...prevState, Site: null, zone: null }))
            setZone(null)
            setSite(null)
        }

    }
    useEffect(() => {
        setFormData({
            Camera_ID: data.Camera_ID,
            Name: data.Name || "",
            url: data.URL,
            Manufacturer: data.Manufacturer,
            Model: data.Model || "",
            IP_Address: data.IP_address,
            Port_Number: data.Port_number,
            Username: data.Username,
            Password: data.Password,
            Zone: data.Zone_ID,
            ZoneName: data.zone?.Zone_name ? data.zone.Zone_name : "",
            Status: data.Status,
            Site: data.zone?.site?.Site_ID ? data.zone.site.Site_ID : "",
            SiteName: data.zone?.site?.Name ? data.zone.site.Name : "",
            Rotation: data.Rotation === 1,
            Rotation_degree: data.Rotation_degree ?? 0,

        });
        if (data.zone.site) {
            setSite(data.zone.site)
            console.log('sata.zone.site ', data.zone.site)
        }
        if (data.zone)
            setZone(data.zone)

    }, [data])

    const handleSearch = (value) => {
        let selectedProduct = {};
        if (value) {
            selectedProduct = products.find(p => p.id == value);
            setFormData({ ...formData, Manufacturer: selectedProduct.manufacturer, Model: selectedProduct.model, productID: value });
        }

        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(async () => {
            const manufacturer = formData.Manufacturer || selectedProduct.manufacturer;
            const model = formData.Model || selectedProduct.model;
            if (manufacturer?.length > 0 || model?.length > 0) {
                const { error, data } = await getProducts(manufacturer, model);
                if (!error) {
                    setProducts(data)

                };
            }
        }, 500);
    };
    const handleUrlChange = (url) => {
        // A camera-ui tunnel URL ("solyntek-enc:<token>") has no host/port of
        // its own to derive -- it's an opaque, already-resolved connection
        // string. Short-circuit here instead of falling into the http(s)/
        // rtsp parser below, which throws on it (no digits where it expects
        // a port) and would otherwise leave IP_Address/Port_Number unset.
        if (url && url.startsWith('solyntek-enc:')) {
            setFormData((prevState) => ({
                ...prevState,
                IP_Address: '0.0.0.0',
                Port_Number: '0',
            }));
            return;
        }
        try {
            const protocolRegex = /^(https?|rtsp|http|rtp):\/\//i;
            const match = url.match(protocolRegex);
            const protocol = match ? match[1] : '';
            const strippedUrl = url.replace(protocolRegex, '');
            const urlObj = new URL(`http://${strippedUrl}`);

            const ip = urlObj.hostname;
            const port = urlObj.port;
            const path = urlObj.pathname;

            const params = new URLSearchParams(urlObj.search);
            const username = params.get('user') || '';
            const password = params.get('pwd') || '';

            const isValidIP = (ip) => {
                const regex = /^(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])$/;
                return regex.test(ip);
            };

            const isValidPort = (port) => {
                const portNumber = parseInt(port, 10);
                return portNumber >= 0 && portNumber <= 65535;
            };

            setFormData((prevState) => ({
                ...prevState,
                IP_Address: isValidIP(ip) ? ip : '0.0.0.0',
                Port_Number: isValidPort(port) ? port : '0',
                Username: username || prevState.Username,
                Password: password || prevState.Password,
                Path: path || prevState.Path,
            }));
        } catch (error) {
            console.error('Invalid URL:', error);
        }
    };
    const handleCreateURL = async () => {
        const pID = formData.productID;

        if (pID) {
            const { error, data } = await getProducts();
            const manuf = data.find(prod => prod.id == pID);
            if (manuf) {
                let url = formData.url;
                let ip = formData.IP_Address;
                let port = formData.Port_Number;
                let username = formData.Username;
                let password = formData.Password;

                let path = manuf.path;
                if (path && path.includes('[USERNAME]')) {
                    path = path.replace('[USERNAME]', username || '[USERNAME]');
                }
                if (path && path.includes('[PASSWORD]')) {
                    path = path.replace('[PASSWORD]', password || '[PASSWORD]');
                }
                path = '/' + path;
                url = `${manuf.protocol}${ip}:${port ? port : manuf.port}${path}`;
                url = url.trim();
                setFormData(prevState => ({
                    ...prevState,
                    url: url
                }));
            }
        }
    };
    const updateUrlWithIpAndPort = (url, ip, port) => {
        try {
            const urlObj = new URL(url);
            if (ip) {
                urlObj.hostname = ip;
            }
            if (port) {
                urlObj.port = port;
            }
            return urlObj.toString();
        } catch (error) {
            console.error('Invalid URL:', error);
            return url;
        }
    };

    const handleChange = (e) => {
        console.log('data edt ', formData)
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
        // Clear error message when user starts typing
        if (formErrors[name]) {
            setFormErrors(prevState => ({
                ...prevState,
                [name]: ''
            }));
        }
        if (name === 'url') {
            handleUrlChange(value);
        }
        if (name === 'IP_Address' || name === 'Port_Number') {
            setFormData(prevState => {
                let updatedUrl = prevState.url;
                const newIp = name === 'IP_Address' ? value : prevState.IP_Address;
                const newPort = name === 'Port_Number' ? value : prevState.Port_Number;
                updatedUrl = updateUrlWithIpAndPort(prevState.url, newIp, newPort);
                return {
                    ...prevState,
                    [name]: value,
                    url: updatedUrl
                };
            });
        };
    }

    const validateForm = async () => {
        try {
            console.log("aa")
            await validateCamera(formData);
            console.log("bb")

            return true; // Form is valid
        } catch (error) {
            const validationErrors = {};
            error.inner.forEach(err => {
                validationErrors[err.path] = err.message;
                console.log('err valid', err.message)
            });
            setFormErrors(validationErrors);
            return false; // Form is invalid
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const isValid = await validateForm();
        if (isValid) {
            try {
                // Assuming formData contains the user data
                const result = await cameraUpdate(formData); // Call the userAdd function with the form data
                if (result.data)
                    closeModal(true); // Close modal or perform other actions
                else
                    setErrorEdit(result.error)
            } catch (error) {
                console.error("Error updating Camera:", error); // Log any errors
                setErrorEdit(error);
            }
        }
    };
    const uniqueManufacturers = new Set();

    const closeModal = (refresh=false) => {
        setFormData({});
        setErrorEdit(null)
        setFormErrors({});
        onClose(refresh);
        setLoading(true)
        setZone(null)
        setSite(null)
    };

    // if (loading) return <FallbackLoading/>;
    // if (!loading)
    return (loading ? <FallbackLoading /> : <form key={data.id} onSubmit={handleSubmit}>
        <div className=" overflow-y-auto grid  gap-7 max-lg:grid-cols-1 grid-cols-2 w-auto m-2 bg-white max-md:p-3 p-8 rounded-3xl shadow-lg">
            <p className="flex justify-center col-span-full text-xl text-[#4C4C66] font-bold mb-4">{t('edit_camera_details')}</p>
            <div className="col-span-full w-1/2 pr-10 max-lg:pr-0 max-lg:w-full max-lg:col-span-1">
                <Input
                    required
                    label={t('camera_name')}
                    name="Name"
                    value={formData.Name}
                    onChange={handleChange}
                    placeholder={t('enter_camera_name')}
                    error={formErrors.Name}
                />
            </div>

            {/* {products && (
                <Select
                    required
                    options={
                        products
                            .filter(prod => {
                                if (!uniqueManufacturers.has(prod.manufacturer)) {
                                    uniqueManufacturers.add(prod.manufacturer);
                                    return true;
                                }
                                return false;
                            })
                            .map(prod => ({
                                label: prod.manufacturer,
                                value: prod.id
                            }))
                    }
                    value={{
                        value: formData.Manufacturer,
                        label: formData.Manufacturer
                    }}
                    label={"Manufacturer"}
                    name="Manufacturer"
                    getInputValue={(value) => { value && setFormData({ ...formData, Manufacturer: value }); handleSearch() }}
                    onChange={(option) => setFormData({ ...formData, Manufacturer: option.label, productID: option.value })}
                    placeholder={t("enter_camera_manufacturer")}
                    error={formErrors.Manufacturer}
                />
            )}
            {products && (
                <Select
                    required
                    options={products.map(prod => ({
                        label: prod.model,
                        value: prod.id
                    }))}
                    value={{
                        value: formData.Model,
                        label: formData.Model
                    }}
                    label={"Model"}
                    getInputValue={(value) => { value && setFormData({ ...formData, Model: value }); handleSearch() }}
                    onChange={(option) => setFormData({ ...formData, Model: option.label, productID: option.value })}
                    placeholder={t("enter_camera_model")}
                    error={formErrors.Model}
                />
            )}
            <Input
                required
                label="IP Address"
                name="IP_Address"
                value={formData.IP_Address}
                onChange={handleChange}
                placeholder={t("enter_camera_ip_address")}
                error={formErrors.IP_Address}
            />
            <Input
                required
                label="Port Number"
                name="Port_Number"
                value={formData.Port_Number}
                onChange={handleChange}
                placeholder={t("enter_camera_port_number")}
                error={formErrors.Port_Number}
            /> */}
            {/* {
                        formData?.Site && */}
            {site?.Name ? (
                <Select
                    isClearable={true}
                    required
                    options={sitesList.map(site => ({
                        label: site.Name,
                        value: site.Site_ID
                    }))}
                    label={t('select_site')}
                    value={{
                        value: site?.Site_ID,
                        label: site?.Name
                    }}
                    className='min-w-[300px]'
                    onChange={(option) => handleSelectSite(option)}
                    placeholder={t('select_site')}
                    error={formErrors.Site}
                />
            ) : (
                <Select
                    isClearable={true}
                    required
                    options={sitesList.map(site => ({
                        label: site.Name,
                        value: site.Site_ID
                    }))}
                    label={t('select_site')}
                    className='min-w-[300px]'
                    onChange={(option) => handleSelectSite(option)}
                    placeholder={t('select_site')}
                    error={formErrors.Site}
                />
            )}
            {/* } */}
            {
                zone?.Zone_name ? (<Select
                    isClearable={true}
                    required
                    options={zonesList.map(zone => ({
                        label: zone.Zone_name,
                        value: zone.Zone_ID
                    }))}
                    label={t('select_zone')}
                    value={{
                        value: zone?.Zone_ID,
                        label: zone?.Zone_name
                    }}
                    onChange={(option) => handleSelectZone(option)}
                    placeholder={t('select_zone')}
                    error={formErrors.Zone}
                />) : (<Select
                    isClearable={true}
                    required
                    options={zonesList.map(zone => ({
                        label: zone.Zone_name,
                        value: zone.Zone_ID
                    }))}
                    label={t('select_zone')}
                    onChange={(option) => handleSelectZone(option)}
                    placeholder={t('select_zone')}
                    error={formErrors.Zone}
                />)
            }
            {/* } */}
            {/* <Input
                // required
                label="Username"
                name="Username"
                value={formData.Username}
                onChange={handleChange}
                placeholder={t("enter_camera_username")}
                error={formErrors.Username}
            />
            <Input
                // required
                type='password'
                label="Password"
                name="Password"
                value={formData.Password}
                onChange={handleChange}
                placeholder={t("enter_camera_password")}
                error={formErrors.Password}
            /> */}
            <div className='col-span-full flex justify-center items-center'>
                <Textarea
                    required
                    label={t('camera_url')}
                    name="url"
                    value={formData.url}
                    onChange={handleChange}
                    placeholder={t('enter_camera_url')}
                    error={formErrors.url}
                />
                {formData.productID &&
                    <Button color={'secondary'} type='button' onClick={handleCreateURL}>{t('generate_url')}</Button>
                }
            </div>

            {isRotationFeatureEnabled && (
                <>
                    <div className="col-span-full flex items-center justify-between border-t border-[#eef1f6] pt-4">
                        <div>
                            <p className="text-sm font-semibold text-[#393939]">{t("rotation")}</p>
                            <p className="text-xs text-[#979797]">{t("camera_rotation_hint")}</p>
                        </div>
                        <button
                            type="button"
                            onClick={() => setFormData(prevState => ({ ...prevState, Rotation: !prevState.Rotation }))}
                            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${formData.Rotation ? "bg-blue-500" : "bg-slate-300"}`}
                        >
                            <span className={`inline-block h-4 w-4 transform rounded-full bg-gray-200 transition-transform ${formData.Rotation ? "translate-x-6" : "translate-x-1"}`} />
                        </button>
                    </div>
                    {formData.Rotation && (
                        <label className="col-span-full block text-xs font-bold text-[#344054]">
                            {t("rotation_degree")}
                            <div className="mt-2 flex items-center gap-2">
                                <input
                                    type="number"
                                    min="0"
                                    max="359"
                                    value={formData.Rotation_degree}
                                    onChange={(event) => {
                                        const value = event.target.value;
                                        setFormData(prevState => ({ ...prevState, Rotation_degree: value }));
                                    }}
                                    onBlur={(event) => {
                                        const value = Number(event.target.value);
                                        setFormData(prevState => ({
                                            ...prevState,
                                            Rotation_degree: Number.isFinite(value) ? Math.max(0, Math.min(359, Math.round(value))) : 0,
                                        }));
                                    }}
                                    className="h-9 min-w-0 flex-1 rounded-md border border-[#dce2eb] bg-[#f5f7fa] px-3 text-xs"
                                />
                                <span className="text-xs font-medium text-[#667085]">°</span>
                            </div>
                        </label>
                    )}
                </>
            )}

            {errorEdit && (
                <div className="col-span-full flex justify-center  space-x-5">

                    <span className=" my-4 ml-2 text-xs text-[#FF0000] ">
                        {errorEdit.response?.data.detail ? `* ${errorEdit.response.data.detail}` : "* error updating camera"}
                    </span>
                </div>

            )}
            <div className='col-span-full flex justify-center mt-10 space-x-5'>
                <Button type="reset" onClick={closeModal} size="large" color="cancel" >{t('cancel')}</Button>
                <Button
                    type="submit"
                    size="large"
                >{t('update_camera')}</Button>
            </div>
        </div>
    </form>);
};

export default EditCameraModal;
